import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { PlanOfCareScreen } from "@/routes/_authenticated/_care/residents/$residentId/-components/documents/plan-of-care-screen";

export const Route = createFileRoute(
  "/_authenticated/_crm/crm/leads/$leadId_/plans-of-care/$planId",
)({
  component: PlanOfCareView,
});

function PlanOfCareView() {
  const { leadId, planId } = Route.useParams();
  // The enquiry stands where the resident would: the same page prints for
  // both, and conversion moves the document without changing it.
  const { data: resident } = useSuspenseQuery(
    orpc.crm.leads.get.queryOptions({ input: { leadId } }),
  );

  return (
    <PlanOfCareScreen
      planId={planId}
      resident={resident}
      back={
        <Link params={{ leadId }} search={{ tab: "physician" }} to="/crm/leads/$leadId">
          Back to the enquiry
        </Link>
      }
      printLabel="Print plan"
      missingDescription="It may have been removed, or it belongs to somebody else. The enquiry lists every plan on file."
    />
  );
}
